module.exports = __webpack_public_path__ + "media/images/partners/stem-70666d7c6c9aab19c9ddc06733d659af.svg";